import {extendTheme} from "@mui/joy";
import {Theme} from "@mui/joy/styles/types";

const colors = {
    light: {
        50: "#E7F5F1",
        100: "#BEE6DB",
        200: "#8FD3C0",
        300: "#5FBEA1",
        400: "#379E82",
        500: "#187A66",
        600: "#0D5C51",
        700: "#0B4340",
        800: "#083530",
        900: "#041D1A",
    },

    dark: {
        50: "#04160F",
        100: "#062018",
        200: "#0A2C22",
        300: "#0F3B2E",
        400: "#15533F",
        500: "#187A66",
        600: "#379E82",
        700: "#5FBEA1",
        800: "#8FD3C0",
        900: "#E7F5F1",
    },
}

const theme = extendTheme({
    fontFamily: {
        body: "Raleway, sans-serif",
        display: "Raleway, sans-serif",
    },
    colorSchemes: {
        light: {
            palette: {
                primary: colors.light,
            }
        },
        dark: {
            palette: {
                primary: colors.dark,
            }
        }
    }
})

/**
 * The palette to read colours from inside a component.
 *
 * `useTheme().palette` resolves to the light scheme, but the app runs in dark mode only (App.tsx
 * pins it). Since the primary scale is inverted between the two schemes, reading the wrong one
 * paints dark navies onto the dark background. Values here are plain hex, so they can be passed
 * to applyTransparency.
 */
export const activePalette = (theme: Theme) => theme.colorSchemes.dark.palette

export function applyTransparency(color: string, opacity: number): string {
    // Ensure opacity is within 0-1
    const alpha = Math.min(Math.max(opacity, 0), 1);

    // HEX color
    if (color.startsWith('#')) {
        let hex = color.slice(1);
        if (hex.length === 3) {
            // e.g., #3bf → #33bbff
            hex = hex.split('').map((c) => c + c).join('');
        }
        const r = parseInt(hex.slice(0, 2), 16);
        const g = parseInt(hex.slice(2, 4), 16);
        const b = parseInt(hex.slice(4, 6), 16);
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }

    // RGB color: rgb(r,g,b)
    const rgbMatch = color.match(/rgb\((\d+),\s*(\d+),\s*(\d+)\)/);
    if (rgbMatch) {
        const [, r, g, b] = rgbMatch;
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }

    throw new Error('Unsupported color format. Use hex (#RRGGBB) or rgb(r,g,b)');
}


export default theme
